export const getUrlParamsFetch = (params: Object): string => {
  const queryParams = new URLSearchParams();

  // Recorrer los parámetros y agregar solo aquellos que tienen un valor
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
        if(typeof value  === 'object'){
           queryParams.append(value['id'], value['value'])
        }
        else{
            queryParams.append(key, value.toString());
        }
     
      // queryParams.append(key, value.toString());
    }
  });

  return queryParams.toString();
};
